export const mutation_add_prestazione_users = `
mutation addPrestazioneUsers($objects: [prestazione_user_insert_input!]!) {
    insert_prestazione_user(objects: $objects) {
        affected_rows
    }
}`;
export const mutation_delete_prestazione_user = `
mutation deletePrestazioneUser($prestazioneId: Int!) {
    delete_prestazione_user(where: {PrestazioneId: {_eq: $prestazioneId}}) {
        affected_rows
    }
}`;